// extracted by mini-css-extract-plugin
module.exports = {"instruction":"style_instruction__3-H8V"};